import { idSchema } from "@reactive-resume/schema";
import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const coverLetterSchema = z.object({
  id: idSchema,
  content: z.string(),
  resumeId: idSchema,
  createdAt: dateSchema,
  updatedAt: dateSchema,
});

export class CoverLetterDto extends createZodDto(coverLetterSchema) {}
